// extracted by mini-css-extract-plugin
export default {"container":"Speech_container__Fe0I4","card":"Speech_card__Pwzdq","image":"Speech_image__oNQaT","textcontainer":"Speech_textcontainer__RaQVA"};